import "../../../src/App.css";
import React, { useState } from "react";
import MiniDrawer from "../../components/MiniDrawer/MiniDrawer";
import Wrapper from "../../components/UI/Wrapper";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import "../../pages/LeadDataReportMaster/LeadDataReportMaster.css";
import { useLocation } from "react-router-dom";
import EstimateList1 from "../../components/EstimateListComponent/EstimateListComponent";

function EstimateList() {
  const location = useLocation();
  const role = location.state?.role;
  const [total, setTotal] = useState(0); // ✅ Track total count

  return (
    <div className="d-flex flex-row app">
      <MiniDrawer />

      <div
        className="container-fluid"
        style={{
          padding: "4rem 1rem 1rem 1rem",
          backgroundColor: "#F4F4F4",
          width: "100%",
          overflowX: "auto",
        }}
      >
        <div
          className="d-flex flex-column w-100"
          style={{ backgroundColor: "#F4F4F4" }}
        >
          {/* -------- Header Section -------- */}
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              marginTop: "1%",
            }}
          >
            <div className="country-header">
              <h1
                style={{
                  fontSize: "24px",
                  marginBottom: "1rem",
                  lineHeight: "1.7",
                }}
              >
                Estimate List | <HomeOutlinedIcon />{" "}
                <span style={{ fontSize: "20px" }}>&gt;&gt; {role}</span>
                <span style={{ fontSize: "20px", paddingLeft: "10px" }}>
                  &gt; Sales Register
                </span>
                <span style={{ fontSize: "20px", paddingLeft: "10px" }}>
                  &gt; Estimate List
                </span>
              </h1>
            </div>

            {/* -------- Total Records Counter -------- */}
            <div className="lead-list-button">
              <p
                className="icon total-records-icon"
                style={{
                  borderColor: "#C0C6CC",
                  border: "1px solid",
                  textAlign: "center",
                  padding: "10px",
                  fontSize: "13px",
                  height: "2.5rem",
                  borderRadius: "0.5rem",
                }}
              >
                <b>Total Records:</b>{" "}
                <span style={{ color: "#5B489D" }}>
                  <b>{total}</b>
                </span>
              </p>
            </div>
          </div>

          {/* -------- Estimate List Component -------- */}
          <Wrapper className="ViewLeadDetails wrapperLeadDataReport">
            <EstimateList1 onTotalChange={setTotal} />
          </Wrapper>
        </div>
      </div>
    </div>
  );
}

export default EstimateList;
